import { render, staticRenderFns } from "./CourseSchedule.vue?vue&type=template&id=45109f1e"
import script from "./CourseSchedule.vue?vue&type=script&lang=js"
export * from "./CourseSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports